"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const csvParser_1 = __importDefault(require("./parsers/csvParser"));
const jsonParser_1 = __importDefault(require("./parsers/jsonParser"));
const parsers = [
    new csvParser_1.default(),
    new jsonParser_1.default(),
];
class TableParser {
    static getParser(extension) {
        for (const parser of parsers) {
            if (parser.fileTypes.indexOf(extension) !== -1) {
                return parser;
            }
        }
        throw new Error("Parser does not exist for file type: " + extension);
    }
    static parseFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            const parser = this.getParser(file.type);
            return parser.parse(yield file.text());
        });
    }
    static parseText(ext, content) {
        const parser = this.getParser(ext);
        return parser.parse(content);
    }
    static parseLine(ext, line) {
        const parser = this.getParser(ext);
        return parser.parseLine(line);
    }
}
exports.default = TableParser;
